const statsTypes = {
  RESET_DASHBOARD_STATE: 'RESET_DASHBOARD_STATE',
  SET_DASHBOARD_FILTERS: {
    REQUEST: 'SET_DASHBOARD_FILTERS.REQUEST',
    SUCCESS: 'SET_DASHBOARD_FILTERS.SUCCESS',
    FAILURE: 'SET_DASHBOARD_FILTERS.FAILURE',
  },
  SET_COUNTRY: {
    REQUEST: 'SET_COUNTRY.REQUEST',
    SUCCESS: 'SET_COUNTRY.SUCCESS',
    FAILURE: 'SET_COUNTRY.FAILURE',
  },
  SET_EXCHANGE_QUEUES_MODAL: 'SET_EXCHANGE_QUEUES_MODAL',
};

export default statsTypes;
